(function () {
  if (window.kwoAtcLabelLoaded) return;
  window.kwoAtcLabelLoaded = true;
  function run() {
    document.querySelectorAll('.quick-add-button, .quick-add-button-variants').forEach(function (el) {
      if (el.textContent.trim() === 'Toevoegen aan winkelwagen') {
        el.textContent = 'Voeg toe';
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 600);
})();